import React from "react";
import { Tab } from "react-admin";

import { PalletsList } from "./PalletsList";

export const PalletsTab = (props) => {
	if (!props.record?.id) return null;

	return (
		<Tab label="Pallets" {...props}>
			<PalletsList order={props.record} terminalId={props.record.terminal_id} {...props} />
		</Tab>
	);
};
